import { render, staticRenderFns } from "./ConnectMatchmaking.vue?vue&type=template&id=07810ca6&scoped=true"
import script from "./ConnectMatchmaking.vue?vue&type=script&lang=js"
export * from "./ConnectMatchmaking.vue?vue&type=script&lang=js"
import style0 from "./ConnectMatchmaking.vue?vue&type=style&index=0&id=07810ca6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07810ca6",
  null
  
)

export default component.exports